<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :sortBy="'startDate'"
    :descending="true"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import { format } from "date-fns";

export default {
  data() {
    return {
      headers: [
        {
          text: "שם",
          value: "user",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let user = this.entityById(
              "users",
              data[key] && data[key]._id ? data[key]._id : data[key]
            );
            return user ? user.name : 'ללא';
          }
        },
        {
          text: "תפקיד",
          value: "role",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let role = this.entityById(
              "roles",
              data[key] && data[key]._id ? data[key]._id : data[key]
            );
            return role ? role["title"] : "ללא תפקיד";
          }
        },
        {
          text: "מזהה אירוע",
          value: "eventId",
          align: "right",
          visible: false,
          width: "200",
          displayFunc: (data, key) => {
            return data['event'] ? data['event']._id : 'לא ידוע';
          }
        },
        {
          text: "אירוע",
          value: "event",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] && data[key].title ? data[key].title : 'לא ידוע';
          },
          linkTo: item => {
            let eventId = item && item.event && item.event._id ? item.event._id : null;
            return eventId ? `/events/${eventId}` : null;
          }
        },
        {
          text: "תיאור האירוע",
          value: "event",
          align: "right",
          visible: true,
          width: "300",
          displayFunc: (data, key) => {
            return data[key] && data[key].description ? data[key].description : 'ללא תיאור';
          }
        },
        {
          text: "זמן התחלה",
          value: "startDate",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY HH:mm");
          }
        },
        {
          text: "זמן סיום",
          value: "endDate",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return data[key]
              ? format(data[key], "DD-MM-YYYY HH:mm")
              : "לא ידוע";
          }
        }
      ],
      filters: [
        {
          type: "COMBOBOX",
          label: "שם",
          model: "users",
          items: "users",
          itemText: "name",
          itemValue: "_id",
          active: true
        },
        {
          type: "COMBOBOX",
          label: "תפקיד",
          model: "roles",
          items: "roles",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "DATE",
          label: "התחיל אחרי",
          model: "startDateAfter",
          active: false
        },
        {
          type: "DATE",
          label: "התחיל לפני",
          model: "startDateBefore",
          active: false
        },
        {
          type: "TEXT",
          label: "חיפוש חופשי",
          model: "search",
          icon: "search",
          expanded: true,
          active: true
        },
        {
          type: "BOOLEAN",
          label: "רק אירועי הראל",
          model: "includedInHarelReports",
          active: true
        }
      ]
    };
  },
  computed: {
    roles() {
      return this.$store.getters["entityList"]("roles").filter(item => {
        return item.isDutyRole;
      });
    },
    users() {
      return Object.values(this.$store.state.entities.users);
    },
    resource() {
      return this.$store.state.resources["duty"];
    },
    optionLists() {
      return {
        users: this.users,
        roles: this.roles
      };
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    }
  },
  watch: {},
  components: {
    AdvancedTable
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/reports/Duties.vue